import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=b8d065c2&scoped=true"
import script from "./HeaderTitle.vue?vue&type=script&lang=ts"
export * from "./HeaderTitle.vue?vue&type=script&lang=ts"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=b8d065c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d065c2",
  null
  
)

export default component.exports